import { Component, computed, inject, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ConstantService, ThemeEnum } from '../../services/common/constant.service';

@Component({
  standalone: false,
  selector: 'app-register-welcome',
  templateUrl: './register-welcome.component.html',
  styleUrls: ['./register-welcome.component.scss']
})
export class RegisterWelcomeComponent implements OnInit, OnDestroy {

  private constantService = inject(ConstantService);
  private activatedRoute = inject(ActivatedRoute);

  showOrgName = computed( ()=> this.constantService.showOrgName );

  logoImage = this.constantService.getSessionStorage(ThemeEnum.signinLogo) ?? "assets/images/logo.png";
  signupBackground = this.constantService.getSessionStorage(ThemeEnum.signupBackground) ?? "assets/images/register-background.png";
  subscriptions: Subscription = new Subscription;
  url: string;

  ngOnInit(): void {
    this.subscriptions.add(this.activatedRoute.queryParams.subscribe(params => {
      const parsedUrl = new URL(params['url']);
      this.url = `${parsedUrl.protocol}//${parsedUrl.hostname}`;
    }));
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  onNavigation() {
    window.location.href = this.url;
  }

}
